import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var LocationQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query locationQuery($zipCode: String) {\n    location(locationRequest: { zipCode: $zipCode }) {\n      state\n      city\n      latitude\n      longitude\n    }\n  }\n"])));
export default LocationQuery;